import { useState } from 'react';
import { useDashboardStorage } from '../../../../../../../../hooks/useDashboardStorage';
const KEYS = [
    'newPost',
    'welcomePost',
    'discord',
    'products',
    'promotions',
    'twitchDiscount',
    'spotify',
];
export const useSuggestionsDismiss = () => {
    const { dashboardStorage } = useDashboardStorage();
    const initialVisibility = KEYS.reduce((acc, key) => ({
        ...acc,
        [key]: !dashboardStorage.get(`membershipsSuggestionsDismiss.${key}`),
    }), {});
    const [visibility, setVisibility] = useState(initialVisibility);
    const dismiss = (key) => {
        setVisibility((prev) => ({ ...prev, [key]: false }));
        dashboardStorage.set(`membershipsSuggestionsDismiss.${key}`, true);
    };
    const suggestionsDismiss = KEYS.reduce((acc, key) => ({
        ...acc,
        [key]: { visible: visibility[key], dismiss: () => dismiss(key) },
    }), {});
    return { suggestionsDismiss };
};
